export default {
  translation: {
    nav: {
      home: 'Home',
      trips: 'Trips',
      aboutUs: 'About Us',
      uganda: 'Uganda',
      wishlist: 'Wishlist',
      language: 'Language',
      profile: 'Profile',
      settings: 'Settings',
      signIn: 'Sign in',
      signUp: 'Sign up',
      mainMenu: 'Main Menu',
      account: 'Account',
      blog: 'Blog',
      adventures: 'Adventures'
    },
    adventures: {
      all: 'All Adventures',
      safariPackages: 'Safari Packages',
      cityTours: 'City Tours',
      culturalTours: 'Cultural Tours',
      selfDrive: 'Self-Drive',
      allExperiences: 'All Experiences',
      gorillaTrekking: 'Gorilla Trekking',
      chimpanzeeTracking: 'Chimpanzee Tracking',
      customizeSafari: 'Customize Your Safari',
      nightlifeGuide: 'Nightlife Guide'
    },
    hero: {
      title: 'Discover Uganda',
      subtitle: 'and beyond',
      description: 'Experience the Pearl of Africa with expert local guides. Unforgettable adventures await in Uganda\'s breathtaking landscapes and vibrant culture.',
      searchPlaceholder: 'Where to?',
      categories: {
        all: 'All',
        wildlife: 'Wildlife',
        safari: 'Safari',
        cultural: 'Cultural',
        adventure: 'Adventure',
        birding: 'Birding'
      },
      stats: {
        experiences: 'Experiences',
        guides: 'Local Guides',
        travelers: 'Happy Travelers',
        rating: 'Average Rating'
      }
    },
    howItWorks: {
      title: 'Why Book with TravelCord',
      subtitle: 'Connecting travelers with authentic experiences and local guides in Uganda',
      features: {
        verifiedGuides: {
          title: 'Verified Local Guides',
          description: 'All our guides are carefully vetted and certified to ensure you get the best experience.'
        },
        bestPrice: {
          title: 'Best Price Guarantee',
          description: 'Find a better price? We will match it and give you an extra 10% off your next booking.'
        },
        flexibleBooking: {
          title: 'Flexible Booking',
          description: 'Free cancellation up to 24 hours before your experience. No questions asked.'
        },
        localExpertise: {
          title: 'Local Expertise',
          description: 'Get authentic insights and hidden gems from guides who know Uganda best.'
        }
      },
      bookingProcess: {
        title: 'Easy Booking Process',
        steps: {
          browse: 'Browse experiences and select your preferred date',
          choose: 'Choose your group size and any special requirements',
          secure: 'Secure your booking with our easy payment system'
        }
      },
      qualityAssurance: {
        title: 'Quality Assurance',
        licensed: 'Licensed and insured guides',
        quality: 'Regular quality checks',
        groups: 'Small groups for better experience'
      },
      support: {
        title: 'Customer Support',
        assistance: '24/7 customer assistance',
        payment: 'Secure payment protection',
        satisfaction: 'Satisfaction guaranteed'
      }
    },
    footer: {
      explore: {
        title: 'Explore',
        description: 'Embark on an extraordinary journey through Uganda\'s untamed wilderness, where mountain gorillas roam ancient forests, lions climb trees in vast savannas, and vibrant cultures welcome you with open arms.',
        findGuides: 'Find Guides',
        safariAdventures: 'Safari Adventures',
        culturalExperiences: 'Cultural Experiences',
        wildlifeTours: 'Wildlife Tours',
        cityExplorations: 'City Explorations'
      },
      about: {
        title: 'About',
        aboutUs: 'About Us',
        becomeGuide: 'Become a Guide',
        partnership: 'Partnership',
        careers: 'Careers',
        press: 'Press Center'
      },
      contact: {
        title: 'Contact',
        address: 'Ntinda, Kampala, Uganda',
        phone: '+256766830194',
        email: 'info@travelcord.guide'
      },
      legal: {
        copyright: '© 2025 TravelCord. All rights reserved.',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        cookies: 'Cookie Policy',
        sitemap: 'Sitemap'
      }
    },
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      retry: 'Try again',
      viewMore: 'View more',
      viewLess: 'View less',
      search: 'Search',
      select: 'Select',
      cancel: 'Cancel',
      submit: 'Submit',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      finish: 'Finish',
      close: 'Close',
      required: 'Required',
      optional: 'Optional',
      from: 'from',
      reviews: 'reviews',
      book: 'Book',
      seeAll: 'See all',
      for: 'for',
      years: 'years'
    },
    experiences: {
      title: 'Top Experiences in Uganda',
      subtitle: 'Booking these popular experiences ahead of time guarantees your spot',
      categories: {
        all: 'All',
        wildlife: 'Wildlife',
        safari: 'Safari',
        cultural: 'Cultural',
        adventure: 'Adventure',
        birding: 'Birding'
      },
      viewDetails: 'View Details'
    },
    cityTours: {
      title: 'City Tours & Experiences',
      subtitle: 'Discover Uganda\'s vibrant cities and their unique attractions'
    },
    giveaway: {
      title: 'Win a Free Safari Across Uganda!',
      subtitle: 'Limited Time Offer',
      description: 'We are giving 19 lucky travelers the ultimate chance to experience Uganda\'s magic for FREE!',
      enterButton: 'I\'m Feeling Lucky',
      whatsIncluded: 'What\'s Included:',
      howItWorks: 'How It Works:',
      eligibility: 'Eligibility:',
      viewTerms: 'View full terms & conditions',
      winners: 'winners to be selected',
      nextWinner: 'Next Winner Announcement In:',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Minutes',
      seconds: 'Seconds',
      enterGiveaway: 'Enter the Giveaway',
      yourEmail: 'Your Email Address',
      enterEmail: 'Enter your email to win',
      entryReceived: 'Entry Received!',
      thankYou: 'Thank you for entering our giveaway! Check your email for confirmation and stay tuned for the winner announcement.',
      pastWinners: 'Past Winners\' Experiences'
    },
    becomeGuide: {
      title: 'Become a TravelCord Guide',
      subtitle: 'Share Uganda\'s Beauty!',
      description: 'Turn your passion for Uganda into a rewarding career. Join our community of expert local guides.',
      benefits: {
        earnings: 'Earn More',
        earningsDesc: 'Keep up to 85% of booking fees',
        reach: 'Global Reach',
        reachDesc: 'Connect with global travelers',
        share: 'Share Gems',
        shareDesc: 'Showcase local experiences',
        flexible: 'Flexible',
        flexibleDesc: 'Work on your schedule'
      },
      stats: {
        guides: 'Active Guides',
        travelers: 'Happy Travelers',
        rating: 'Average Rating',
        commission: 'Commission Rate'
      },
      features: {
        profile: 'Professional profile & booking system',
        payments: 'Secure payment processing',
        marketing: 'Marketing & promotional support',
        support: '24/7 customer support'
      },
      applyNow: 'Apply Now'
    },
    success: {
      title: 'Submission Successful!',
      message: 'Thank you for your submission. We have received your request and will contact you soon.',
      returnHome: 'Return to Homepage'
    },
    forms: {
      booking: {
        title: 'Book This Experience',
        personalInfo: 'Personal Information',
        tourDetails: 'Tour Details',
        payment: 'Payment Details',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email Address',
        phone: 'Phone Number',
        date: 'Date',
        travelers: 'Travelers',
        specialRequests: 'Special Requests',
        total: 'Total',
        submit: 'Complete Booking'
      },
      quote: {
        title: 'Request Quote',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        submit: 'Send Request'
      }
    },
    pages: {
      aboutUs: {
        title: 'About Us',
        subtitle: 'Connecting Travelers with Local Expertise',
        description: 'Discover our story, mission, and dedicated team.',
        ourStory: 'Our Story',
        ourValues: 'Our Values',
        contactUs: 'Contact Us'
      },
      allExperiences: {
        title: 'All Experiences in Uganda',
        subtitle: 'Discover our complete collection of authentic Ugandan experiences',
        filters: 'Filters',
        sortBy: 'Sort by',
        noResults: 'No experiences found',
        resetFilters: 'Reset filters'
      },
      blog: {
        title: 'Uganda Safari & Travel Blog',
        subtitle: 'Expert guides, tips, and stories about gorilla trekking, game drives, and cultural experiences',
        searchPlaceholder: 'Search safari guides, gorilla trekking...',
        featuredStories: 'Featured Stories',
        categories: 'Categories',
        popularTopics: 'Popular Topics',
        newsletterTitle: 'Safari Updates',
        writeForUs: 'Write for Us'
      },
      careers: {
        title: 'Join Our Team',
        subtitle: 'Help us showcase Uganda\'s beauty to the world',
        benefits: 'Benefits',
        openPositions: 'Open Positions',
        applicationForm: 'Application Form'
      },
      cityTours: {
        title: 'Uganda City Tours',
        subtitle: 'Discover Uganda\'s vibrant cities with our local guides',
        kampala: 'Kampala Tours',
        jinja: 'Jinja Tours',
        entebbe: 'Entebbe Tours',
        bookNow: 'Book Now'
      },
      customizeAdventure: {
        title: 'Customize Your Adventure',
        subtitle: 'Create your perfect Ugandan experience',
        chooseGuide: 'Choose Your Guide',
        customizeExperience: 'Customize Your Experience',
        finalDetails: 'Final Details',
        requestQuote: 'Request Quote'
      },
      gorillaTrekking: {
        title: 'Gorilla Trekking in Uganda',
        subtitle: 'Meet mountain gorillas in their natural habitat',
        essentialInfo: 'Essential Information',
        bestTime: 'Best Time',
        requirements: 'Requirements',
        whatToBring: 'What to Bring'
      },
      guideProfile: {
        title: 'Guide Profile',
        experience: 'Experience',
        languages: 'Languages',
        specialties: 'Specialties',
        reviews: 'Reviews',
        tours: 'Tours Completed',
        bookNow: 'Book Now',
        contactGuide: 'Contact Guide',
        aboutGuide: 'About Guide',
        certifications: 'Certifications',
        achievements: 'Achievements'
      },
      nightlife: {
        title: 'Uganda Nightlife Guide',
        subtitle: 'Your ultimate guide to exploring Uganda\'s vibrant nightlife scene',
        packages: 'All-Inclusive Packages',
        clubs: 'Clubs & Bars',
        streetFood: 'Street Food Circuit',
        safety: 'Safety & Etiquette',
        bookNow: 'Book Now',
        essentials: 'Night Crawling Essentials',
        bestNights: 'Best Nights',
        peakHours: 'Peak Hours',
        startingPoint: 'Starting Point',
        dressCode: 'Dress Code',
        whatsIncluded: 'What\'s Included in Your Package',
        vipEntry: 'VIP Club Entry',
        vipEntryDesc: 'Skip the lines with VIP access to all clubs and venues. No cover charges or entry fees - it\'s all included!',
        foodDrinks: 'Food & Drinks',
        foodDrinksDesc: 'Enjoy complimentary street food tastings and welcome drinks at each venue. Additional drink options available.',
        safetyGuidance: 'Safety & Guidance',
        safetyGuidanceDesc: 'Professional guides and security personnel ensure your safety throughout the night while showing you the best spots.',
        whyBookWithUs: 'Why Book With Us',
        photoPackage: 'Photo Package Add-on',
        photoPackageDesc: 'Capture your night with our professional photography add-on. A dedicated photographer will join your group to document your experience.',
        groupBooking: 'Group Booking Benefits',
        groupBookingDesc: 'Booking as a group? Enjoy special benefits and discounts when you book for 4 or more people!',
        contactGroup: 'Contact for Group Bookings',
        contactGroupDesc: 'For groups of 4 or more, contact our team for special arrangements and discounts.',
        streetFoodCircuit: 'Street Food Circuit',
        nightMarkets: 'Night Markets & Bazaars',
        nightclubScene: 'Nightclubbing Scene',
        tierSystem: 'Uganda\'s Famous 3-Tier System',
        platinumTier: 'Platinum Tier Clubs',
        goldTier: 'Gold Tier Clubs',
        undergroundScene: 'Underground Scene',
        safetyEtiquette: 'Safety & Etiquette',
        safetyPriority: 'Your Safety is Our Priority',
        clubEntryTips: 'Club Entry Tips',
        transport: 'Transport',
        proTips: 'Pro Tips from Our Guides',
        weeklyHighlights: 'Weekly Highlights',
        faq: 'Frequently Asked Questions',
        readyToExperience: 'Ready to Experience Uganda\'s Nightlife?',
        readyToExperienceDesc: 'Book your all-inclusive nightlife package today and let us handle everything while you enjoy an unforgettable night out!',
        viewPackages: 'View Packages',
        contactUs: 'Contact Us',
        lastUpdated: 'Last updated',
        contributor: 'Contributor',
        reportChanges: 'Report changes'
      },
      partnership: {
        title: 'Partner with TravelCord',
        subtitle: 'Join Uganda\'s leading tourism platform',
        opportunities: 'Partnership Opportunities',
        benefits: 'Benefits',
        application: 'Partnership Application',
        testimonials: 'Testimonials'
      },
      resources: {
        title: 'Uganda Travel Resources',
        subtitle: 'Downloadable guides, maps, and checklists',
        categories: 'Resource Categories',
        download: 'Download Free Guide',
        testimonials: 'What Travelers Say'
      },
      safariPackages: {
        title: 'Safari Packages',
        subtitle: 'Discover our carefully curated safari packages',
        filters: 'Filters',
        priceRange: 'Price Range',
        duration: 'Duration',
        viewDetails: 'View Details',
        bookNow: 'Book Now'
      },
      selfDriveSafaris: {
        title: 'Self-Drive Safaris in Uganda',
        subtitle: 'Explore Uganda at your own pace',
        chooseVehicle: 'Choose Your Vehicle',
        customizeExperience: 'Customize Your Experience',
        requirements: 'Requirements',
        roadConditions: 'Road Conditions',
        safetyGuidelines: 'Safety Guidelines'
      },
      travelGuides: {
        title: 'Expert Local Guides in Uganda',
        subtitle: 'Connect with our experienced local guides',
        filters: 'Filters',
        sortBy: 'Sort by',
        specialties: 'Specialties',
        languages: 'Languages',
        viewProfile: 'View Profile'
      },
      uganda: {
        title: 'Welcome to Uganda',
        subtitle: 'Discover the Pearl of Africa',
        nationalParks: 'National Parks',
        popularActivities: 'Popular Activities',
        bestTimeToVisit: 'Best Time to Visit',
        travelTips: 'Travel Tips'
      },
      writeForUs: {
        title: 'Write for TravelCord',
        subtitle: 'Share your Uganda travel experiences',
        guidelines: 'Submission Guidelines',
        whatWeLookFor: 'What We\'re Looking For',
        requirements: 'Article Requirements',
        benefits: 'Benefits',
        submitPitch: 'Submit Pitch'
      }
    }
  }
};